"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isConstructor = void 0;
function isConstructor(f) {
    return typeof f === 'function';
}
exports.isConstructor = isConstructor;
//# sourceMappingURL=isConstructor.js.map